export enum PortfolioType {
    Discretionary = 1,
    TaxFree = 3
}